import AssetLanding from './AssetLanding';

export default AssetLanding;